import React, { FC, ReactNode, useLayoutEffect } from "react";

interface Props {
  title: string;
  children?: ReactNode;
}

const Page: FC<Props> = ({ title, children }) => {
  useLayoutEffect(() => {
    document.title = [title, 'PacerPro'].filter((it) => !!it).join(' | ');
  }, [title]);
  return <>{ children }</>;
}

export default Page